import { Box, Button, SpaceBetween } from '@amzn/awsui-components-react';
import { match, useHistory, useRouteMatch } from 'react-router-dom';

import { constants } from '../../common/Localization';
import { MatchParam } from '../../common/types';

interface TableEmptyStateProps {
    resourceName: string;
    resourceType?: string;
    import?: boolean;
}

const TableEmptyState = (props: TableEmptyStateProps): JSX.Element => {
    const match: match<MatchParam> | null = useRouteMatch({
        path: '/portfolio/:portfolioId',
    });

    const portfolioId = match?.params?.portfolioId;

    const history = useHistory();
    const actionImportClick = (): void => {
        history.push({
            pathname: `/portfolio/${portfolioId}/management/import-from-file`,
            state: {
                fromType: props.resourceType,
            }
        });
    };
    const importButton = (
        props.import && props.resourceType &&
            <Button variant="primary" id="import" onClick={actionImportClick}>{constants.IMPORT_FROM_FILE}</Button>
    );

    return (
        <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
            <SpaceBetween size="s">
                <div>
                    <b>No {props.resourceName.toLowerCase()}</b>
                </div>
                {importButton}
            </SpaceBetween>
        </Box>
    );
};

export default TableEmptyState;
